<template>
    <base-layout>
        <ksef-details-modal ref="ksefDetailsModal"/>
        <h1 slot="header">
            {{ `app.pages.orders` | trans}}
        </h1>
        <v-app id="vuetify-app">
            <v-container fluid>
                <v-layout row wrap align-center>
                    <v-flex xs12 d-flex>
                        <order-form
                                method="PATCH"
                                :model="model"
                                @closed="model = null"
                        ></order-form>
                    </v-flex>
                </v-layout>
              <v-layout row wrap align-center>
                <v-flex xs12 d-flex>
                  <invoice-form
                      method="PATCH"
                      :model="invoice"
                      @closed="invoice = null"
                  ></invoice-form>
                </v-flex>
              </v-layout>
                <v-layout row justify-end>
                    <v-flex xs2 pa-2>
                        <v-menu
                                v-model="cal"
                                :close-on-content-click="true"
                                :nudge-right="40"
                                lazy
                                transition="scale-transition"
                                offset-y
                                full-width
                                min-width="290px"
                        >
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                        v-model="invoice_month"
                                        readonly
                                        clearable
                                        single-line
                                        hide-details
                                        solo
                                        :label="trans('app.month')"
                                        v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker v-model="invoice_month" @input="cal = false" locale="pl-pl"
                                           type="month"></v-date-picker>
                        </v-menu>
                    </v-flex>
                    <v-flex xs2 d-flex pa-2>
                        <loading-button :loading="isLoading" :status="status" @click="downloadInvoices()"
                                        :disabled="invoice_month === null">
                            {{ 'app.download_invoices' | trans }}
                        </loading-button>
                    </v-flex>
                </v-layout>
                <v-layout row wrap>
                    <v-flex pa-2>
                        <v-text-field
                                v-model="filters.id"
                                append-icon="search"
                                :label="trans('app.id')"
                                single-line
                                clearable
                                hide-details
                                solo
                        ></v-text-field>
                    </v-flex>
                    <v-flex pa-2>
                        <v-combobox
                                clearable
                                :items="[{text: trans('page.orders.open'), value: 'open'},{text: trans('page.orders.closed'), value: 'closed'},{text: trans('page.orders.canceled'), value: 'canceled'},{text: trans('page.orders.pending'), value: 'pending'},{text: trans('page.orders.rejected'), value: 'rejected'}]"
                                :label="trans('app.status')"
                                v-model="filters.status"
                                hide-details
                                solo
                        ></v-combobox>
                    </v-flex>
                    <v-flex pa-2 v-if="isKsefEnabled">
                      <v-combobox
                          clearable
                          :items="ksefStatuses"
                          :label="trans('app.ksef.ksef_status')"
                          v-model="filters.ksef_status"
                          hide-details
                          solo
                      ></v-combobox>
                    </v-flex>
                    <v-flex pa-2>
                        <v-menu
                                v-model="menu"
                                :close-on-content-click="true"
                                :nudge-right="40"
                                lazy
                                transition="scale-transition"
                                offset-y
                                full-width
                                min-width="290px"
                        >
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                        v-model="filters.date"
                                        readonly
                                        clearable
                                        single-line
                                        hide-details
                                        solo
                                        :label="trans('app.created_at')"
                                        v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker v-model="filters.date" @input="menu = false" locale="pl-pl"></v-date-picker>
                        </v-menu>
                    </v-flex>
                    <v-flex xs12 sm6 md6 pa-2>
                        <v-combobox
                                attach
                                clearable
                                :items="subscriptionTypes"
                                :label="trans('app.subscription')"
                                v-model="filters.subscription"
                                hide-details
                                solo
                        ></v-combobox>
                    </v-flex>
                    <v-flex xs12 sm6 md6 pa-2>
                        <v-text-field
                                v-model="filters.query"
                                append-icon="search"
                                :label="trans('app.search.search')"
                                single-line
                                hide-details
                                clearable
                                solo
                        ></v-text-field>
                    </v-flex>
                </v-layout>
                <v-layout row wrap align-start>
                  <v-flex xs12>
                        <resource-table ref="table" endpoint="/administrator/orders" :headers="headers"
                                        :filters="filters">
                            <template #content="{item}">
                                <tr :class="{ 'unconfirmed-order': isUnconfirmed(item), 'ksef-failed': isKsefFailed(item) }">
                                    <td>
                                        {{ item.id }}
                                    </td>
                                    <td>
                                        {{ item.invoice_number || '-' }}
                                    </td>
                                    <td>
                                        {{ item.created_at }}
                                    </td>
                                    <td>
                                        {{ item.paid_at }}
                                    </td>
                                    <td>
                                        {{ item.userName }}
                                        <div class="caption grey--text">{{ item.userEmail }}</div>
                                    </td>
                                    <td class="text-xs-center">
                                        <v-tooltip top v-if="item.subscriptionName">
                                            <template #activator="{ on }">
                                                <v-icon v-on="on" small :color="subscriptionCategoryColor(item.subscription_type_category)">draw</v-icon>
                                            </template>
                                            <span>{{ item.subscriptionName }}</span>
                                        </v-tooltip>
                                        <span v-else>-</span>
                                    </td>
                                    <td>
                                        {{ item.amount | money }}
                                    </td>
                                    <td v-if="item.discount !== null">
                                        {{ item.discount | money }}
                                    </td>
                                    <td v-else-if="item.estimated_discount !== null">
                                        {{ item.estimated_discount | money }}
                                    </td>
                                    <td v-else>
                                        -
                                    </td>
                                    <td>
                                        {{ item.with_discount | money }}
                                    </td>
                                    <td class="text-xs-center">
                                        <v-tooltip top>
                                            <template #activator="{ on }">
                                                <v-icon v-on="on" small :color="orderStatusColor(item.status)">{{ orderStatusIcon(item.status) }}</v-icon>
                                            </template>
                                            <span>{{ trans('page.orders.' + item.status) }}</span>
                                        </v-tooltip>
                                    </td>
                                    <td class="text-xs-center">
                                      <template v-if="isKsefEnabled && item.has_ksef">
                                        <v-tooltip top>
                                            <template #activator="{ on }">
                                                <v-icon v-on="on" small :color="ksefStatusColor(item.ksef_status)">{{ ksefStatusIcon(item.ksef_status) }}</v-icon>
                                            </template>
                                            <span>{{ trans('app.ksef.ksef_statuses.' + item.ksef_status) }}</span>
                                        </v-tooltip>
                                      </template>
                                      <span v-else>-</span>
                                    </td>
                                    <td class="justify-end layout px-0 pr-4">
                                        <v-tooltip top>
                                            <template #activator="{ on }">
                                                <v-btn
                                                        v-on="on"
                                                        flat
                                                        icon
                                                        color="green"
                                                        class="mr-0 ml-0"
                                                        :disabled="isLoading"
                                                        @click="editItem(item)"
                                                        v-if="!item.has_ksef || item.ksef_status !== 'accepted'">
                                                    <v-icon small>edit</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>{{ 'app.edit' | trans}}</span>
                                        </v-tooltip>
                                        <v-tooltip top>
                                          <template #activator="{ on }">
                                            <v-btn
                                                v-on="on"
                                                flat
                                                icon
                                                color="blue"
                                                class="mr-0 ml-0"
                                                :disabled="isLoading"
                                                @click="editInvoice(item)"
                                                v-if="item.status === 'closed' && (!item.has_ksef || item.ksef_status !== 'accepted')">
                                              <v-icon small>edit</v-icon>
                                            </v-btn>
                                          </template>
                                          <span>{{ 'app.invoice.edit' | trans}}</span>
                                        </v-tooltip>
                                        <v-tooltip top>
                                            <template #activator="{ on }">
                                                <v-btn
                                                        v-on="on"
                                                        flat
                                                        icon
                                                        color="green"
                                                        class="mr-0 ml-0"
                                                        :disabled="isLoading"
                                                        @click="downloadInvoice(item)"
                                                        v-if="item.status === 'closed'">
                                                    <v-icon small>description</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>{{ 'app.invoice.invoice' | trans}}</span>
                                        </v-tooltip>
                                        <v-tooltip top>
                                          <template #activator="{ on }">
                                            <v-btn
                                                v-on="on"
                                                flat
                                                icon
                                                color="blue"
                                                class="mr-0 ml-0"
                                                :disabled="isLoading"
                                                @click="sendToKsef(item)"
                                                v-if="isKsefEnabled && item.has_ksef && item.status === 'closed' &&
                                                (item.ksef_status === 'to_send' || item.ksef_status === 'rejected' || item.ksef_status === 'failed')">
                                              <v-icon small>send</v-icon>
                                            </v-btn>
                                          </template>
                                          <span>{{ 'app.ksef.send_to_ksef' | trans}}</span>
                                        </v-tooltip>
                                        <v-tooltip top>
                                          <template #activator="{ on }">
                                            <v-btn
                                                v-on="on"
                                                flat
                                                icon
                                                color="blue"
                                                class="mr-0 ml-0"
                                                :disabled="isLoading"
                                                @click="checkKsefStatus(item)"
                                                v-if="isKsefEnabled && item.has_ksef && item.status === 'closed' &&
                                                  (item.ksef_status === 'processing_by_ksef')">
                                              <v-icon small>refresh</v-icon>
                                            </v-btn>
                                          </template>
                                          <span>{{ 'app.ksef.check_ksef_status' | trans}}</span>
                                        </v-tooltip>
                                        <v-tooltip top>
                                          <template #activator="{ on }">
                                            <v-btn
                                                v-on="on"
                                                flat
                                                icon
                                                color="green"
                                                class="mr-0 ml-0"
                                                :disabled="isLoading"
                                                @click="openKsefDetailsModal(item)"
                                                v-if="isKsefEnabled && item.has_ksef && item.status === 'closed'">
                                              <v-icon small>launch</v-icon>
                                            </v-btn>
                                          </template>
                                          <span>{{ 'app.ksef.ksef_details' | trans}}</span>
                                        </v-tooltip>
                                        <v-tooltip top>
                                            <template #activator="{ on }">
                                                <v-btn
                                                        v-on="on"
                                                        flat
                                                        icon
                                                        color="blue"
                                                        class="mr-0 ml-0"
                                                        :disabled="isLoading"
                                                        @click="confirmPayment(item)"
                                                        v-if="item.status === 'open' || item.status === 'pending'">
                                                    <v-icon small>payment</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>{{ 'app.confirm_payment' | trans}}</span>
                                        </v-tooltip>
                                        <v-tooltip top v-if="item.status !== 'closed'">
                                            <template #activator="{ on }">
                                                <v-btn
                                                        v-on="on"
                                                        flat
                                                        icon
                                                        color="red"
                                                        class="mr-0 ml-0"
                                                        :disabled="isLoading"
                                                        @click="deleteItem(item)">
                                                    <v-icon small>delete</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>{{ 'app.delete' | trans}}</span>
                                        </v-tooltip>
                                    </td>
                                </tr>
                            </template>
                        </resource-table>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-app>
    </base-layout>
</template>

<script>
    import {trans} from '../../../app';
    import {mapGetters, mapState} from 'vuex';
    import {DIETITIAN_STUDENT} from "../../../utils/roles";

    export default {

    data: () => ({
      items: [],
      isLoading: false,
      status: '',
      model: null,
      invoice: null,
      menu: false,
      cal: false,
      invoice_month: null,
      waitingForKsefSave: false,
      filters: {
        query: null,
        id: null,
        status: null,
        date: null,
        subscription: null,
        ksef_status: null,
      },
      pagination: {},
      errors: {},
      ksefStatuses: [
        {
          text: trans('app.ksef.ksef_statuses.to_send'),
          value: 'to_send'
        },
        {
          text: trans('app.ksef.ksef_statuses.sending'),
          value: 'sending'
        },
        {
          text: trans('app.ksef.ksef_statuses.sent'),
          value: 'sent'
        },
        {
          text: trans('app.ksef.ksef_statuses.processing_by_ksef'),
          value: 'processing_by_ksef'
        },
        {
          text: trans('app.ksef.ksef_statuses.accepted'),
          value: 'accepted'
        },
        {
          text: trans('app.ksef.ksef_statuses.rejected'),
          value: 'rejected'
        },
        {
          text: trans('app.ksef.ksef_statuses.failed'),
          value: 'failed'
        }
      ]
    }),

    mounted () {
      this.$root.$on('stored', this.onStored);
      this.$root.$on('ksef-save-started', this.onKsefSaveStarted);
      this.$root.$on('ksef-save-finished', this.onKsefSaveFinished);
    },
    computed: {
      ...mapGetters(['hasPermission', 'isKsefEnabled']),
      ...mapState(['dictionaries']),
      subscriptionTypes () {
        return this.dictionaries.subscriptions.map(({ id, name, price, duration }) => ({
          text: this.prepareSubscriptionName(name, price, duration),
          value: id,
        }));
      },
      headers() {
        if (this.isKsefEnabled) {
          return       [
            {
              text: trans('app.id'), align: 'left', value: 'id', sortable: true,
            },
            {
              text: trans('app.invoice.number'), align: 'left', value: 'invoice_number', sortable: true,
            },
            {
              text: trans('app.created_at'), align: 'left', value: 'created_at', sortable: true,
            },
            {
              text: trans('app.paid_at'), align: 'left', value: 'paid_at', sortable: true,
            },
            {
              text: trans('app.email'), align: 'left', value: 'userName', sortable: false,
            },
            {
              text: trans('app.subscription'), align: 'center', value: 'subscriptionName', sortable: false,
            },
            {
              text: trans('app.amount'), align: 'left', value: 'amount', sortable: true,
            },
            {
              text: trans('app.discount'), align: 'left', value: 'discount', sortable: true,
            },
            {
              text: trans('app.with_discount'), align: 'left', value: 'with_discount', sortable: false,
            },
            {
              text: trans('app.status'), align: 'center', value: 'status', sortable: true,
            },
            {
              text: trans('app.ksef.ksef_status'), align: 'center', value: 'ksef_status', sortable: true,
            },
            {
              text: '', align: 'center', value: '', sortable: false,
            },
          ];
        }
        return [
          {
            text: trans('app.id'), align: 'left', value: 'id', sortable: true,
          },
          {
            text: trans('app.invoice.number'), align: 'left', value: 'invoice_number', sortable: true,
          },
          {
            text: trans('app.created_at'), align: 'left', value: 'created_at', sortable: true,
          },
          {
            text: trans('app.paid_at'), align: 'left', value: 'paid_at', sortable: true,
          },
          {
            text: trans('app.user'), align: 'left', value: 'userName', sortable: false,
          },
          {
            text: trans('app.subscription'), align: 'center', value: 'subscriptionName', sortable: false,
          },
          {
            text: trans('app.amount'), align: 'left', value: 'amount', sortable: true,
          },
          {
            text: trans('app.discount'), align: 'left', value: 'discount', sortable: true,
          },
          {
            text: trans('app.with_discount'), align: 'left', value: 'with_discount', sortable: false,
          },
          {
            text: trans('app.status'), align: 'center', value: 'status', sortable: true,
          },
          {
            text: '', align: 'center', value: '', sortable: false,
          },
        ]
      },
    },
    methods: {
      subscriptionCategoryColor(category) {
        const colorMap = {
          premium: 'amber',
          standard: 'blue',
          student: 'green',
          individual: 'purple',
          test: 'orange',
        };
        return colorMap[category] || 'grey';
      },
      orderStatusIcon(status) {
        const iconMap = {
          canceled: 'cancel',
          open: 'schedule',
          closed: 'check_circle',
          rejected: 'highlight_off',
          pending: 'hourglass_empty',
        };
        return iconMap[status] || 'help_outline';
      },
      orderStatusColor(status) {
        const colorMap = {
          canceled: 'grey',
          open: 'blue',
          closed: 'green',
          rejected: 'red',
          pending: 'orange',
        };
        return colorMap[status] || 'grey';
      },
      ksefStatusIcon(status) {
        const iconMap = {
          to_send: 'outgoing_mail',
          sending: 'cloud_upload',
          sent: 'mark_email_read',
          processing_by_ksef: 'sync',
          accepted: 'check_circle_outline',
          rejected: 'remove_circle_outline',
          failed: 'error_outline',
        };
        return iconMap[status] || 'help_outline';
      },
      ksefStatusColor(status) {
        const colorMap = {
          to_send: 'grey',
          sending: 'blue',
          sent: 'blue',
          processing_by_ksef: 'orange',
          accepted: 'green',
          rejected: 'red',
          failed: 'red',
        };
        return colorMap[status] || 'grey';
      },
      editItem (item) {
        this.model = { ...item };
      },
      prepareSubscriptionName(name, price, duration) {
        if (price && duration) {
          return `${name} (${duration} dni, ${price} zł)`;
        }

        return name;
      },
      deleteItem (item) {
        this.$confirmDanger(
            trans('app.confirm_removal'),
            trans('app.remove') + ' ' + trans('app.pages.orders').toLowerCase()
        ).then(async () => {
          this.isLoading = true;
          await axios.delete('/administrator/orders/' + item.uuid);
          await this.$refs.table.fetchData();
          this.$toast(trans('app.removed'));
          this.isLoading = false;
        }).catch((error) => {
          this.isLoading = false;
          this.$toast.error(trans('app.error_occurred'));
          this.sentryCaptureException(error);
        })
      },

      async downloadInvoice (item) {
        axios.post('/administrator/orders/' + item.uuid + '/createInvoicePdf')
            .then(() => {
              this.isLoading = true;
            })
            .catch(error => {
              this.$toast.error(trans('app.error_occurred'));
              this.isLoading = false;
              this.sentryCaptureException(error);
            })
      },

      downloadInvoices () {
        this.isLoading = true;
        const [year, month] = this.invoice_month.split('-');

        axios.post(`/administrator/orders/invoice/${year}/${month}`)
        .catch((error) => {
          this.sentryCaptureException(error);
          this.isLoading = false;
          this.status = false;
        })
      },

      confirmPayment (item) {
        this.$confirmWarning(trans('app.confirm_payment')).then(async () => {
          this.isLoading = true;
          await axios.get('/administrator/orders/' + item.uuid + '/confirmPayment');
          await this.$refs.table.fetchData();
          this.$toast(trans('app.order_confirmed'));
          this.isLoading = false;
        }).catch((error) => {
          this.isLoading = false;
          this.$toast.error(trans('app.error_occurred'));
          this.sentryCaptureException(error);
        })
      },
      editInvoice(item) {
        axios.get('/administrator/orders/' + item.uuid + '/invoice')
        .then((response) => {
          this.invoice = response.data.data;
        })
        .catch((error) => {
          this.sentryCaptureException(error);
        })
      },
      isUnconfirmed(item) {
        return item.subscription_type_role_to_assign === DIETITIAN_STUDENT && item.student_status_verified === 0 && item.status === 'open';
      },
      isKsefFailed(item) {
        return item.has_ksef && (item.ksef_status === 'rejected' ||  item.ksef_status === 'failed');
      },
      sendToKsef(item) {
        this.$confirmWarning(trans('app.ksef.confirm_send_to_ksef')).then(async () => {
          this.isLoading = true;
          await axios.post('/administrator/orders/' + item.uuid + '/sendToKsef');
          await this.$refs.table.fetchData();
          this.$toast(trans('app.ksef.sending_started'));
          this.isLoading = false;
        }).catch((error) => {
          this.isLoading = false;
          this.$toast.error(trans('app.error_occurred'));
          this.sentryCaptureException(error);
        })
      },
      openKsefDetailsModal(item) {
        this.$refs.ksefDetailsModal.open(item.uuid);
      },
      async checkKsefStatus(item) {
        await axios.post('/administrator/orders/' + item.uuid + '/checkKsefStatus');
        this.$toast(trans('app.ksef.ksef_status_check_started'));
      },
      onStored() {
        if (!this.waitingForKsefSave) {
          this.$refs.table.fetchData();
        }
      },
      onKsefSaveStarted() {
        this.waitingForKsefSave = true;
      },
      onKsefSaveFinished() {
        this.waitingForKsefSave = false;
        this.$refs.table.fetchData();
      }
    },
    async created() {
      setTimeout(()=> {
        window.Echo.private('invoices-archive-created-' + window.user.id)
            .listen('InvoicesArchiveCreatedEvent', (e) => {
              axios.get(e.url, {
                headers: {
                  'Accept': 'application/zip',
                },
                responseType: 'arraybuffer',
              }).then(({data}) => {
                const downloadUrl = window.URL.createObjectURL(new Blob([data]));
                const link = document.createElement('a');
                link.href = downloadUrl;
                link.setAttribute('download', 'invoice.zip');
                document.body.appendChild(link);
                link.click();
                link.remove();
                this.status = true;
                this.isLoading = false;
              }).catch((error) => {
                this.isLoading = false;
                this.status = false;

                if (error.response && error.response.status === 404) {
                  this.$toast(trans('app.no_invoices'));
                } else {
                  this.sentryCaptureException(error);
                }
              });
            });
      }, 1000);
      setTimeout(() => {
        window.Echo.private('invoice-pdf-created-' + window.user.id)
            .listen('InvoicePdfCreatedEvent', (e) => {
              axios.get(e.url, {
                responseType: 'arraybuffer',
              }).then(({data}) => {
                const downloadUrl = window.URL.createObjectURL(new Blob([data]));
                const link = document.createElement('a');
                link.href = downloadUrl;
                link.setAttribute('download', e.fileName);
                document.body.appendChild(link);
                link.click();
                link.remove();
                this.isLoading = false;
              }).catch((error) => {
                this.isLoading = false;
                this.sentryCaptureException(error);
              });
            });

      }, 1000);
      setTimeout(() => {
        window.Echo.private('ksef-invoice-status-checked-' + window.user.id)
            .listen('.KsefInvoiceStatusChecked', (e) => {
              if (e.successful) {
                this.$refs.table.fetchData();
                this.$toast.success(trans('app.ksef.ksef_status_check_completed'));
                return;
              }
              this.$toast.error(trans('app.ksef.ksef_status_check_failed'));
            })
      }, 1000);
    }
  };
</script>
<style scoped>
  .unconfirmed-order {
    background-color: #ffde3c;
  }
  .ksef-failed {
    background-color: #f36969;
  }
  >>> table.v-table thead th {
    padding-right: 12px;
    padding-left: 12px;
  }
  >>> table.v-table tbody td {
    padding-right: 12px;
    padding-left: 12px;
  }
</style>
